import { render } from "./LButtom.vue?vue&type=template&id=cadf6de8&scoped=true&ts=true"
import script from "./LButtom.vue?vue&type=script&lang=ts"
export * from "./LButtom.vue?vue&type=script&lang=ts"

import "./LButtom.vue?vue&type=style&index=0&id=cadf6de8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadf6de8"]])

export default __exports__